/**
 * This file was auto-generated by Fern from our API Definition.
 */
import * as core from "../../../../core";
import { SheetId } from "../../commons/types/SheetId";
import { ViewConfig } from "./ViewConfig";
export const ViewCreate = core.serialization.object({
    sheetId: SheetId,
    name: core.serialization.string(),
    config: ViewConfig,
});
